import { render, staticRenderFns } from "./SliAdminFields.vue?vue&type=template&id=39de12c6"
import script from "./SliAdminFields.vue?vue&type=script&lang=js"
export * from "./SliAdminFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports